import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from '../../assets/styles/style.sass';
import footerStyle from './footer.sass';
import { getTranslation, getLink } from '../../service/asset-json';

class OrderingFooter extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
  };

  render() {
    const { currentLocale } = this.props;

    return (
      <footer className={`${s.order}`}>
        <div className={`${footerStyle.fixedContainer}`}>
          <div className={`${s.footerFunction}`}>
            <a href={getLink('home', currentLocale)}>
              {getTranslation('page_home', currentLocale)}
            </a>|
            <a href={getLink('help_center', currentLocale)}>
              {getTranslation('page_help_center', currentLocale)}
            </a>|
          </div>
          <div className={`${s.footerNav}`}>
            <a href={getLink('about', currentLocale)}>
              {getTranslation('page_about_us', currentLocale)}
            </a>|
            <a href={getLink('service', currentLocale)}>
              {getTranslation('page_service', currentLocale)}
            </a>|
            <a href={getLink('pricing', currentLocale)}>
              {getTranslation('page_pricing', currentLocale)}
            </a>|
            <a href={getLink('business', currentLocale)}>
              {getTranslation('page_business', currentLocale)}
            </a>|
            <a href={getLink('privacy', currentLocale)}>
              {getTranslation('page_privacy', currentLocale)}
            </a>
          </div>
        </div>
      </footer>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
});
export default connect(mapState)(
  withStyles(bootstrap, s, footerStyle)(OrderingFooter),
);



// WEBPACK FOOTER //
// ./src/components/Footer/OrderingFooter.js